import axios from "axios";
import {jwtDecode} from "jwt-decode";
import dayjs from "dayjs";
import * as qs from 'qs'


class BaseApi {
    constructor() {
        this.baseHost = process.env.REACT_APP_API_HOST;
        this.baseUrl = `${this.baseHost}/api/v2/`;
        const instance = axios.create();
        instance.interceptors.request.use(
            (config) => {
                config._retry = false;
                let authTokens = localStorage.getItem("authTokens")
                    ? typeof localStorage.getItem("authTokens") === "string"?JSON.parse(localStorage.getItem("authTokens")): localStorage.getItem("authTokens") : null;
                if (authTokens !== null) {
                    if (authTokens.access){
                        const user = jwtDecode(authTokens.access);
                        const isExpired = dayjs.unix(user.exp).diff(dayjs(), 'seconds') < 0;
                        if (!isExpired) {
                            config.headers["Authorization"] = `Bearer ${authTokens.access}`;
                        }
                    }
                }
                return config;
            },
            (error) => Promise.reject(error)
        );
        instance.interceptors.response.use(
            this.handleSuccess,
            this.handleError.bind(this)
        );
        this.instance = instance;
    }

    handleSuccess(response) {
        return response;
    }

    handleError(error) {
        let finalResponse;
        const config = error.config;
        const configUrl = config.url;
        const retryCondition = [
            !configUrl.includes("auth/token/"),
            !config._retry,
            error.response.status === 401,
        ].every(el => !!el);
        if (retryCondition) {
            config._retry = true;
            let authTokens = localStorage.getItem("authTokens")
                    ? typeof localStorage.getItem("authTokens") === "string"?JSON.parse(localStorage.getItem("authTokens")): localStorage.getItem("authTokens") : null;
            if (authTokens) {
                axios.post(`${this.baseUrl}auth/token/refresh/`, {refresh: authTokens.refresh})
                    .then((response) => {
                        authTokens.access = response.data.access;
                        authTokens.refresh = response.data.refresh;
                        localStorage.setItem('authTokens', JSON.stringify(authTokens));
                    })
                    .catch((error) => {
                        let addr = new URL(document.URL);
                        console.error(error);
                        console.log(addr)
                        window.location.replace("/login/?next="+addr.pathname);
                        localStorage.removeItem('authTokens');
                        finalResponse = error.response;
                    })
                config.headers["Authorization"] = `Bearer ${authTokens.access}`;
                finalResponse = this.instance(config);
            } else {
                let addr = new URL(document.URL);
                window.location.replace("/login/?next="+addr.pathname);
            }
        } else {
            finalResponse = error.response;
        }
        return finalResponse
    }

    async get(url, params, arrayFormat) {
        return await this.instance.get(`${this.baseUrl}${url}`, {
            params: params,
            paramsSerializer: params => qs.stringify(params, {
                arrayFormat: arrayFormat?arrayFormat:'indices',
            })
        })
    }

    async post(url, data, multipart = false) {
        const config = multipart ? {headers: {'Content-Type': 'multipart/form-data'}} : {};
        return await this.instance.post(`${this.baseUrl}${url}`, data, config);
    }

    async patch(url, data, multipart = false) {
        const config = multipart ? {headers: {'Content-Type': 'multipart/form-data'}} : {};
        return await this.instance.patch(`${this.baseUrl}${url}`, data, config);
    }

    async delete(url) {
        return await this.instance.delete(`${this.baseUrl}${url}`);
    }
}

export default BaseApi